import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';
import {StaticPathPipe} from '../../../shared/pipes/static-path.pipe';
import { CommunicationService } from '../../../services/communication.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { SCREEN_SIZE } from '../../../classes/enums';

@Component({
  selector: 'app-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss', './profile-header.desktop.component.scss', './profile-header.mobile.component.scss']
})
export class ProfileHeaderComponent extends HasSubscriptions implements OnInit {
  @Input() name: string = '';
  @Input() description: string = '';
  @Input() preNameText?: string; // Text that goes above where the name is
  @Input() imageUrl?: string; // Whether or not to use an image instead of the map
  @Input() latLng?: google.maps.LatLngLiteral; // Whether or not to use the map instead of the imageURL
  @Input() initials?: string; // Fallback to Initials if picture cannot be found, only for agent profile

  @Input() isAgentProfile: boolean = false;
  @Input() agentRating: number;
  @Input() agentReviews: number;
  @Output() reviewsClicked = new EventEmitter<void>();

  shouldShowInitials: boolean = false;

  screenSize: SCREEN_SIZE;
  SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    private staticPathPipe: StaticPathPipe,
    private communicationService: CommunicationService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSub(this.communicationService.screenSize.subscribe(size => this.screenSize = size));
  }

  imgErrorHandler(event) {
    if (this.isAgentProfile) {
      this.shouldShowInitials = true;
    }
    else {
      event.target.src = this.staticPathPipe.transform('/assets/BalloonLarge.svg');
    }
  }
}
